import { Box, Container } from "@mui/material";
import type { ReactNode } from "react";
import { Footer } from "./Footer";
import { Header } from "./Header";
import backgroundImg from "../images/background.jpg";
export function Layout(props: { children: ReactNode }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundImage: `url(${backgroundImg})`,
        backgroundRepeat: "repeat",
      }}
    >
      <Header />

      {/* Main content area */}
      <Box component="main" sx={{ flex: "1 0 auto" }}>
        {props.children}
      </Box>

      {/* Footer sticks to bottom */}
      <Box sx={{ mt: "auto" }}>
        <Footer />
      </Box>
    </Box>
  );
}
